// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1DVq0","rightAdornment":"Header_rightAdornment__PDoMX"};